import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import { V2, pickLang } from "../copy";
import { route } from "../paths";
import { Arrow } from "./Primitives";

/** The two doors: build a service, or ask for a photo estimate. Ink context. */
const DoorsV2: React.FC<{ className?: string }> = ({ className = "" }) => {
  const { currentLanguage } = useLanguage();
  const lang = pickLang(currentLanguage);
  const c = V2[lang].process;

  return (
    <div className={`grid gap-4 sm:grid-cols-2 ${className}`}>
      <Link
        to={route(lang, "sur-mesure")}
        className="v2-reveal group flex items-center justify-between gap-4 rounded-2xl bg-bone p-6 text-ink transition-transform duration-500 hover:-translate-y-1 sm:p-8"
      >
        <div>
          <div className="font-display text-2xl sm:text-3xl">{c.cta1.title}</div>
          <div className="mt-1 text-sm text-ink/60">{c.cta1.sub}</div>
        </div>
        <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-ink text-bone transition-transform duration-500 group-hover:rotate-[-45deg]">
          <Arrow />
        </span>
      </Link>
      <Link
        to={route(lang, "devis")}
        className="v2-reveal group flex items-center justify-between gap-4 rounded-2xl border border-bone/20 p-6 transition-all duration-500 hover:-translate-y-1 hover:border-tangerine sm:p-8"
        data-delay="1"
      >
        <div>
          <div className="font-display text-2xl sm:text-3xl">{c.cta2.title}</div>
          <div className="mt-1 text-sm text-bone/60">{c.cta2.sub}</div>
        </div>
        <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full border border-bone/30 transition-all duration-500 group-hover:rotate-[-45deg] group-hover:bg-tangerine group-hover:text-white">
          <Arrow />
        </span>
      </Link>
    </div>
  );
};

export default DoorsV2;
